module.exports = {"411481100":"演集镇","411481101":"城关镇","411481102":"芒山镇","411481103":"高庄镇","411481104":"酇城镇","411481105":"裴桥镇","411481106":"马桥镇","411481107":"薛湖镇","411481108":"蒋口镇","411481109":"陈集镇","411481110":"十八里镇","411481111":"太邱镇","411481112":"李寨镇","411481113":"苗桥镇","411481114":"顺和镇","411481115":"茴村镇","411481116":"酇阳镇","411481117":"龙岗镇","411481118":"马牧镇","411481119":"王集镇","411481120":"刘河镇","411481121":"双桥镇","411481122":"卧龙镇","411481200":"城厢乡","411481201":"候岭乡","411481202":"黄口乡","411481203":"新桥乡","411481217":"条河乡","411481219":"陈官庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411481.json
// module id = 1517
// module chunks = 0